import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Typography,
    styled,
    Card,
    Grid,
    Divider,
    List,
    ListItem,
    ListItemText,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';


import * as yup from 'yup';

import { useFormik } from 'formik';

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
// import DataGridToolbar from '../../common/DataGridToolbar';
// import DataGridTable from '../../common/DataGridTable';
// import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import CommonRestricted from '../../common/CommonRestricted';

// import { icons } from '../../common/CommonIcons';
// import { useDataGridParams, dataGridFilterTypes, dataGridFilterTypesProps } from '../../../hooks/useDataGridParams';
import { useSchedulers, schedulerTypes, targetTypes, schedulerConfigs } from '../../../hooks/api/useSchedulers';

import { useSchedulerServer } from '../../../hooks/schedulerApi/useSchedulerServer';

import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { useAppContextFeatures } from '../../../context/AppContext';

import CommonSectionHeader from '../../common/CommonSectionHeader';

export const validationSchema = yup.object({
    taskId: yup
        .string()
        .required('Required'),
})

export const initialValues = {
    taskId: "",
}

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    minHeight: 450
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

export default function ConsoleMain({
    routeType
}) {

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType);

    const { list: listAvailableTasks, filterOperatorTypes } = useSchedulers({ schedulerType: schedulerTypes.schedulerTask });

    const { setSystemLoading } = useAppContextFeatures()

    const {
        listRunningTasks,
        listStopTasks,
        stopById,
        startById,
        addTasks
    } = useSchedulerServer({ serverConfig: schedulerConfigs?.schedulerServer?.config })

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.scheduler.id, scopeTypes.scheduler.task.id)

    const { getHtmlHead } = useSystemHead(routeType)

    const [data, setData] = useState({
        running: [],
        stop: [],
    })

    const [dataTasks, setDataTasks] = useState([])

    const fetchAvailableTasks = async () => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                offset: 0,
                filterValue: [
                    {
                        name: "status",
                        operator: filterOperatorTypes.eq,
                        value: "1"
                    }
                ],
                sortInfo: {
                    id: "id",
                    dir: 0,
                }
            }

            const result = await listAvailableTasks(props)

            // console.log('result', result)

            setDataTasks(result?.data?.scheduler_tasks)

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const fetchSchedulerServerTasks = async () => {

        setSystemLoading(true)

        try {

            const resultRunning = await listRunningTasks()
            const resultStop = await listStopTasks()

            // console.log('result', result)

            setData(prev => ({
                ...data,
                running: resultRunning?.tasks,
                stop: resultStop?.tasks
            }))

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const submitStopById = async ({ idArray }) => {

        setSystemLoading(true)

        try {

            const result = await stopById({ idArray })

            // console.log('result', result)

            promptMessage(false, `${idArray.length} tasks stopped`)

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const submitStartById = async ({ idArray }) => {

        setSystemLoading(true)

        try {

            const result = await startById({ idArray })

            // console.log('result', result)

            promptMessage(true, `${idArray.length} tasks started`)

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const handleAddTask = async (currentValues) => {

        setSystemLoading(true)

        try {

            let idArray = [currentValues?.taskId]

            const result = await addTasks({ idArray })

            console.log('result', result)

            promptMessage(false, `${idArray.length} tasks added to the scheduler routine`)

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (currentValues) => {
            await handleAddTask(currentValues)
            await fetchSchedulerServerTasks()
        }
    });

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

    useEffect(() => {

        fetchSchedulerServerTasks()
        fetchAvailableTasks()

    }, [])

    const handleStop = async ({ id }) => {

        await submitStopById({ idArray: [id] })
        await fetchSchedulerServerTasks()

    }

    const handleStart = async ({ id }) => {

        await submitStartById({ idArray: [id] })
        await fetchSchedulerServerTasks()

    }

    const RenderAddTask = () => {

        // if (!data?.availableTasks) return <></>

        return (
            <StyledCard
                sx={{
                    minHeight: 'auto'
                }}
            >
                {/* {JSON.stringify(dataTasks)} */}
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

                            <CommonSectionHeader
                                title={`Add Tasks`}
                                subTitle={`Append tasks into scheduler routine`}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                            <FormControl
                                margin="dense"
                                fullWidth
                                size="small"
                            // error={touched.postcode && Boolean(errors.postcode)}
                            >
                                <InputLabel id="taskId">Task</InputLabel>
                                <Select
                                    margin='dense'
                                    labelId="taskId"
                                    label="Task"
                                    name={"taskId"}
                                    onChange={handleChange}
                                    // value={
                                    //     checkPostcodeExists()
                                    // }
                                    value={values?.taskId}
                                    sx={{
                                        textAlign: 'left'
                                    }}
                                >

                                    {
                                        dataTasks.map((i, index) => {
                                            return (
                                                <MenuItem key={index} value={i?.task_key}>{i?.task_key} ({i?.name})</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                {/* <FormHelperText>
                                    {touched.postcode && errors.postcode}
                                </FormHelperText> */}
                            </FormControl>

                        </Grid>

                        <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                            <Button
                                fullWidth
                                variant='contained'
                                color="primary"
                                type='submit'
                            >
                                Add Task
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </StyledCard>
        )
    }

    const RenderRunning = () => {

        if (!data?.running) return <></>

        // const { product } = data;

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Running Tasks`}
                            subTitle={`All Tasks which is running state`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <List
                            disablePadding
                            sx={{
                                mx: 1
                            }}
                        >
                            {
                                data?.running.map((i, index) => {
                                    return (
                                        <ListItem
                                            key={index}
                                            disableGutters
                                            disablePadding
                                            divider
                                            sx={{
                                                display: "flex",
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <ListItemText
                                                primary={i?.id}
                                                secondary={i?.task?.id}
                                            />
                                            <Button
                                                variant='contained'
                                                color="error"
                                                onClick={() => {
                                                    handleStop({ id: i?.id })
                                                }}
                                            >
                                                Stop Task
                                            </Button>
                                        </ListItem>

                                    )
                                })
                            }
                        </List>

                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderStop = () => {

        if (!data?.stop) return <></>

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Stopped Tasks`}
                            subTitle={`All Tasks which is stop state`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <List
                            disablePadding
                            sx={{
                                mx: 1
                            }}
                        >
                            {
                                data?.stop.map((i, index) => {
                                    return (
                                        <ListItem
                                            key={index}
                                            disableGutters
                                            disablePadding
                                            divider
                                            sx={{
                                                display: "flex",
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <ListItemText
                                                primary={i?.id}
                                                secondary={i?.task?.id}
                                            />
                                            <Button
                                                variant='contained'
                                                color="primary"
                                                onClick={() => {
                                                    handleStart({ id: i?.id })
                                                }}
                                            >
                                                Start Task
                                            </Button>
                                        </ListItem>

                                    )
                                })
                            }
                        </List>

                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderMain = () => {
        return (
            <Grid container spacing={1} textAlign={"left"}>
                <Grid item md={12}>
                    <RenderAddTask />
                </Grid>
                <Grid item md={6}>
                    <RenderRunning />
                </Grid>
                <Grid item md={6}>
                    <RenderStop />
                </Grid>
            </Grid>
        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ scopeType: scopeTypes[scopeIds.scheduler.id].task.id, functionType: functionTypes.pageList.id })) {
            props.push(
                {
                    displayText: "Manage Tasks",
                    onClick: () => {
                        navigate(getRoute(`settings/schedulers`))
                    }
                },
                {
                    displayText: "Manage Logs",
                    onClick: () => {
                        navigate(getRoute(`settings/scheduler/logs`))
                    }
                },
                {
                    displayText: "Manage Requests",
                    onClick: () => {
                        navigate(getRoute(`settings/scheduler/requests`))
                    },
                }
            )
        }

        return props
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.console })
            }

            {/* {JSON.stringify(data)} */}

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="Scheduler Console"
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Scheduler Console",
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {/* {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        } */}
                        {
                            RenderMain()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
